const platforms = [
  { name: "微博", color: "#E6162D", url: "https://mzniuniu.cn" },
  { name: "抖音", color: "#161823", url: "https://www.douyin.com" },
  { name: "贴吧", color: "#F08200", url: "https://tieba.baidu.com" },
  { name: "B站", color: "#00A1D6", url: "https://www.bilibili.com" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-[0.08]"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=abstract%20warm%20gradient%20of%20coral%20red%20orange%20and%20cream%20with%20soft%20melting%20shapes%20and%20gentle%20grain%2C%20editorial%20magazine%20background%2C%20no%20text%2C%20minimal%20artistic%20poster%20feel&width=1600&height=900&seq=chigua-hero-2026&orientation=landscape)",
        }}
        aria-hidden="true"
      ></div>
      <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-primary-500/5 to-transparent" aria-hidden="true"></div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-14 text-center md:py-20">
        <a
          href="#jieru"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-300/70 bg-accent-100/70 px-4 py-1.5 text-sm font-medium text-accent-900 transition-colors hover:border-accent-400"
        >
          <i className="ri-fire-line text-base" aria-hidden="true"></i>
          全网热点入口 · 今日持续更新
        </a>

        <h1 className="font-heading mt-6 max-w-3xl text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
          一条路线，直达全网
          <span className="text-primary-600">吃瓜现场</span>
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          微博、抖音、贴吧、B站……不用再到处翻链接找入口。吃瓜路线把这些平台的热点入口
          统一整理到一个页面，跟着分类走，轻松围观每一场网络盛事。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#jieru"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-[15px] font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-compass-3-line text-lg" aria-hidden="true"></i>
            直达平台入口
          </a>
          <a
            href="#reyi"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-7 py-3.5 text-[15px] font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 sm:w-auto"
          >
            <i className="ri-fire-line text-lg" aria-hidden="true"></i>
            看看今日热议
          </a>
        </div>

        <div className="mt-9 flex flex-wrap items-center justify-center gap-2">
          <span className="text-sm text-foreground-600">常去现场</span>
          {platforms.map((p) => (
            <a
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noopener nofollow noreferrer"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3.5 py-1.5 text-sm text-foreground-800 transition-all hover:-translate-y-0.5 hover:border-background-300"
            >
              <span className="h-2 w-2 rounded-full" style={{ backgroundColor: p.color }} aria-hidden="true"></span>
              {p.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}